
import buildNumber from '../build-number.json';
export const BUILD_NUMBER = buildNumber.buildNumber;
export const BUILD_DATE = buildNumber.buildDate;